"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCommandCenter() {
  const [joshImage, setJoshImage] = React.useState("https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610811/img/image_syqfnhol.jpg");
  const handleJoshImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setJoshImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "Connor Jackman",
    description: "Partner & Cofounder. Connor specializes in streamlining the closing process for our nationwide clients.",
    image: "https://brentwoodenterprisesllc.com/wp-content/uploads/2026/04/Connor-Jackman_22.jpg?v=2b7guj65j46",
    colSpan: "col-span-1 md:col-span-1 lg:col-span-1",
    link: "/SellYourLandPage",
    Text: ""
  }, {
    title: "Josh Jackman",
    description: "Partner & Cofounder. Josh focuses on evaluating land opportunities and ensuring fair cash offers for every seller.",
    image: joshImage,
    colSpan: "col-span-1 md:col-span-1 lg:col-span-1",
    link: "/SellYourLandPage",
    Text: ""
  }];
  return <section data-section-id="108" id="meettheteam" ref={ref} className={`dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden transition-opacity duration-700 flex flex-col items-center justify-center min-h-screen ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-sans font-extrabold tracking-tighter mb-4 bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
            The Brentwood Team
          </h2>
          <p className="text-muted-foreground text-lg font-sans">
            Meet the professionals committed to providing simple, fast, and fair land solutions. 
            We buy vacant land nationwide with cash and quick closes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 justify-center justify-items-center items-center">
          {features.map((feature, i) => <div key={i} data-index={i} className={`${feature.colSpan} group relative mx-auto w-full max-w-sm rounded-md transition-all duration-300`}>
              {}
              <div className="absolute -inset-[1px] rounded-md bg-gradient-to-r from-primary/0 via-accent/0 to-secondary/0 opacity-0 group-hover:opacity-100 group-hover:from-primary group-hover:to-accent transition-all duration-500 blur-sm" />
              
              {}
              <div className="relative h-full rounded-md bg-card p-[1px] ring-1 ring-white/5 group-hover:ring-transparent transition-all duration-300 overflow-hidden">
                {}
                <div className="absolute inset-0 rounded-md bg-gradient-to-br from-secondary/80 to-card/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {}
                <Card className="relative h-full bg-card/40 backdrop-blur-xl border-none shadow-none rounded-md">
                  <CardHeader>
                    <div className="mb-6 flex flex-col items-center">
                      <div className="mt-8 mx-auto flex size-52 items-center justify-center rounded-none bg-white/5 border border-white/10 backdrop-blur-md shadow-inner shadow-white/5 group-hover:scale-110 transition-transform duration-300 overflow-hidden">
                        <img src={feature.image} alt={feature.title} className="size-full object-cover" />
                      </div>
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 -translate-x-2 group-hover:translate-x-0 mt-4">
                         <ArrowRight className="text-accent size-5" />
                      </div>
                    </div>
                    {feature.title === "Josh Jackman" && <div className="mb-6 flex justify-center relative z-20">
                        <div className="w-full max-w-[150px]">
                          <input type="file" accept="image/*" capture onChange={handleJoshImageChange} className="block w-full text-transparent file:hidden file:mr-0 file:py-2 file:px-4 file:rounded-md file:border file:border-accent/30 file:text-[10px] file:font-sans file:font-bold file:uppercase file:tracking-widest file:bg-accent/10 file:text-accent hover:file:bg-accent/20 cursor-pointer transition-all focus:outline-none" />
                        </div>
                      </div>}
                    <CardTitle className="text-2xl font-sans font-extrabold tracking-tight text-foreground text-center">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-sm font-mono leading-relaxed text-muted-foreground text-center">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                  
                  {}
                  <Link to={feature.link} className="absolute inset-0 z-10 rounded-md ![margin:0px_0px_6px_0px] focus:outline-none focus:ring-2 focus:ring-accent/50" aria-label={`Learn more about ${feature.title}`} />
                </Card>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button size="lg" className="rounded-md px-8 text-base font-sans font-bold bg-primary hover:bg-accent text-primary-foreground transition-colors duration-300" asChild>
            <Link to="#">
              Get Your Cash Offer
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}